exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".addressImportedMetadataMenuChip{cursor:pointer !important}.addressImportedMetadataMenuChip:hover{box-shadow:0 5px 15px rgba(0,0,0,.8)}", ""]);
